/** @jsxImportSource @emotion/react */
import Link from 'next/link'
import { Box, Text } from 'grommet'
import { useTranslation } from 'next-i18next'

import { routes } from 'routes'
import Chip from 'components/Chip'
import useDeviceSize from 'hooks/useDevice'
import { useProvider } from 'hooks/useMoodPlot'
import EmotionChip from 'components/emotion/EmotionChip'

export default function SelectedEmotions({ hideEmptySlots = false }) {
  const { t } = useTranslation()
  const { small } = useDeviceSize()
  const {
    state: { emotionWords, moods, emotionsLimit, existingMoods },
    removeEmotionWord,
  } = useProvider()
  const emotionsLeft = emotionsLimit - existingMoods
  if (hideEmptySlots && (!emotionWords || !moods || moods.length === 0)) {
    return null
  }
  return (
    <Box
      align="center"
      direction="column"
      pad={{ horizontal: '4rem' }}
      margin={{
        top: small ? 'large' : 'small',
        bottom: small ? '4rem' : undefined,
      }}>
      {emotionsLeft > 0 &&
        [...new Array(emotionsLeft).keys()].map((index) => {
          const chip = (
            <Chip
              fill
              key={index}
              chipColor="#dbdbdb"
              showCloseIcon={false}
              css={{ height: '2rem' }}
              label={
                index >= emotionsLeft ? (
                  <Box direction="row" fill="horizontal">
                    <Link href={routes.pricing} passHref>
                      <Text
                        as="a"
                        size="small"
                        color="#999"
                        textAlign="center"
                        css={{ flexGrow: 1, textDecoration: 'none' }}>
                        {t('limits.emotions-count')}
                      </Text>
                    </Link>
                  </Box>
                ) : undefined
              }
            />
          )

          const mood = moods[index]
          if (!mood || mood.angle === null) return chip

          const emotion = emotionWords.find((e) => e.id === mood.emotion_id)
          if (!emotion) return chip

          return (
            <EmotionChip
              fill
              showCloseIcon
              height="2rem"
              emotion={emotion}
              angle={mood.angle}
              key={mood.emotion_id}
              onClick={() => removeEmotionWord(mood.emotion_id)}
            />
          )
        })}
    </Box>
  )
}
